/**
 * AlertBridge — Vue 컴포넌트 외부에서 Alert를 사용하기 위한 브릿지
 * 
 * AlertProvider가 mount될 때 registerAlert()로 등록하면
 * main.js 등 Vue 외부에서 showError() 등을 호출할 수 있습니다.
 * 
 * 주 용도: unhandledrejection 핸들러에서 서버 에러 메시지 표시
 */

let _alert = null

/**
 * AlertProvider에서 mount 시 호출하여 alert 함수들을 등록
 * @param {{ error: Function, info: Function, warning: Function, success: Function }} alert
 */
export const registerAlert = (alert) => {
  _alert = alert
}

/**
 * 에러 토스트 표시 (Vue 외부에서 호출 가능)
 * @param {string|object} message 
 */
export const showError = (message) => {
  // object가 전달된 경우 message 속성 추출 또는 문자열 변환
  const msg = typeof message === 'object' && message !== null
    ? (message.message || message.data?.message || message.error?.message || JSON.stringify(message))
    : message
  if (_alert?.error) {
    _alert.error({ message: msg })
  } else {
    console.error('[alertBridge] Alert not registered yet:', msg)
  }
}

/**
 * 정보 토스트 표시 (Vue 외부에서 호출 가능)
 * @param {string} message
 */
export const showInfo = (message) => {
  if (_alert?.info) {
    _alert.info({ message })
  }
}

/**
 * 알림 모달 표시 — window.alert 대체 (Vue 외부에서 호출 가능)
 * @param {string} message
 */
export const showAlert = (message) => {
  if (_alert?.showAlert) {
    return _alert.showAlert(message)
  }
}
